import { PciChartProps } from "reports/types";
import WeeklyMultiShiftBarChart from "../../../../../components/Reports/GenericCharts/WeeklyMultiShiftBarChart";
import {
  producing,
  unplanned,
  untagged,
  waiting,
  notScheduled,
  planned,
} from "../../../../../constants/colors";
import PciCustomLegend from "reports/pages/customers/pci/Utils/PciCustomLegend";

const bars = [
  {
    key: "producing",
    name: "Producing",
    stackId: "Primary",
    fill: producing,
    label: true,
    labelPos: "center",
  },
  {
    key: "unplanned",
    name: "Unplanned",
    stackId: "Primary",
    fill: unplanned,
    label: false,
  },
  {
    key: "waiting",
    name: "Waiting",
    stackId: "Primary",
    fill: waiting,
    label: false,
  },
  {
    key: "unknown",
    name: "Unknown",
    stackId: "Primary",
    fill: untagged,
    label: false,
  },
  {
    key: "planned",
    name: "Planned",
    stackId: "Primary",
    fill: planned,
    label: false,
  },
  {
    key: "notScheduled",
    name: "Unscheduled",
    stackId: "Primary",
    fill: notScheduled,
    label: false,
  },
];

export default function ShiftBreakdown({ data, width, height }: PciChartProps) {
  const title = "Shift Breakdown (Hours)";
  return (
    <WeeklyMultiShiftBarChart
      data={data ? data : []}
      xLabel=""
      yLabel="Time Distribution (hours)"
      title={title}
      bars={bars}
      width={width}
      height={height}
      legend={PciCustomLegend(width, title)}
    />
  );
}
